import React, { useEffect, useState } from "react";
import LessonNavBar from "components/Navbars/LessonNavBar.js";
import LessonFooterNav from "components/NavigationButton/LessonFooterNav.js";
import PromptLabHubComponent from "components/PromptLabHub/PromptLabHubComponent.js";
import { getV4LessonMetaByRoute, getNextV4LessonRoute } from "pages/claudeDevV4Course/devV4LessonsRegistry.js";

// The single lesson page for every "Claude AI Developer V4" (CD04) lesson.
//
// CD01 and CD02 each ship one hand-written component per lesson — 38 files for
// CD02's original modules alone, verified byte-for-byte identical apart from a
// route string. Nothing in them is per-lesson: the layout (promptLab / canvas /
// template / webLab / hotspot / checklist) is chosen at runtime by
// PromptLabHubComponent from `lessonMeta.layout`. CD03 renders all of its lessons
// through one component driven by the registry, and CD04 does the same for all 43.

const V4LessonPageInner = ({ route, setAiPageContext, setCurrentCode, setCurrentOuput }) => {
    const meta = getV4LessonMetaByRoute(route);
    const nextRoute = getNextV4LessonRoute(route);
    const [allCompleted, setAllCompleted] = useState(false);

    useEffect(() => {
        setAiPageContext?.("claudeCourseLesson");
    }, [setAiPageContext]);

    // The navbar sits before <main>, not inside it, so the header is not part
    // of the main landmark. The wrapper keeps the old full-height background.
    return (
        <div className="lessonBackgroundColor1 lessonMain" style={{ minHeight: "100vh" }}>
            <LessonNavBar />
            <main id="main" tabIndex={-1} className="lessonMain">
                <section>
                    <PromptLabHubComponent
                        lessonMeta={meta}
                        setallCheckboxesCompleted={setAllCompleted}
                        setCurrentCode={setCurrentCode}
                        setCurrentOuput={setCurrentOuput}
                    />
                </section>
                <LessonFooterNav route={route} nextRoute={nextRoute} showNext={allCompleted} />
            </main>
        </div>
    );
};

// `key={route}` is load-bearing, not cosmetic.
//
// With one component per lesson, navigating Lesson 1 -> Lesson 2 swaps one component
// TYPE for another, so React unmounts and remounts and every lesson starts clean.
// Sharing a single component removes that: React sees the same type in the same
// position and reconciles instead, keeping the old instance and its state alive.
//
// That breaks PromptLabHubComponent specifically. Its "load or generate the lesson
// definition" effect is guarded by `didInitRef`, a ref set to true on first run and
// never reset, so a reused instance would never fetch the new lesson — the student
// would click Next and keep reading the previous lesson. Local state here
// (`allCompleted`) would be just as stale.
//
// Keying an inner component on the route restores the remount, and doing it here
// rather than at the <Route> keeps the guarantee with the component: no caller can
// wire CD04's routes in a way that loses it.
const V4LessonPage = (props) => <V4LessonPageInner key={props.route} {...props} />;

export default V4LessonPage;
